import { useState, useEffect } from "react";
import useAuth from "./useAuth";
import { STOCKITEMS_BASE_URL } from "../config";
import API from "../API";

const initialState = {
  payrates: [],
  page: 0,
  total_pages: 0,
  total_results: 0,
};

export const usePayratesListFetch = () => {
  const auth = useAuth();
  const [payratestate, setState] = useState(initialState);
  const [payratesearchValue, payratesetSearchValue] = useState("");
  const [includeInactive, setIncludeInactive] = useState(false);
  const [payrateloading, setLoading] = useState(false);
  const [payrateerror, setError] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [firstLoad, setFirstLoad] = useState(true); // ✅ Prevent double fetching

  const accessToken = auth.auth.accessToken;

  const fetchPayratesList = async (page, searchValue, reset = false) => {
    if (!hasMore && !reset) return; // Stop fetching if no more pages

    try {
      setLoading(true);
      setError(false);

      console.log(reset)

      const data = await API.fetchPayrates(searchValue, page, includeInactive, "", accessToken);
        
      console.log(data)
      setState((prev) => ({
        ...prev,
        payrates: reset ? data.payrates : data.payrates, // ✅ Only reset on filter/search change
        page: page + 1,
        total_pages: data.total_pages,
        total_results: data.total_results,
      }));

      setHasMore(data.payrates.length > 0);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching stock items:", error);
      setError(true);
    }
  };

  useEffect(() => {
    if (firstLoad) {
      setFirstLoad(false);
      fetchPayratesList(1, payratesearchValue, true);
    }
  }, [firstLoad]); // ✅ Runs only once when the component mounts

  useEffect(() => {
    fetchPayratesList(1, payratesearchValue, true); // ✅ Fetch when search/filter changes
  }, [payratesearchValue, includeInactive]);

  return { payratestate, payrateloading, payrateerror,payratesearchValue, payratesetSearchValue, setIncludeInactive, fetchPayratesList };
};
